import { GetterTree } from 'vuex';
import { CourseState } from './state';
import RootState from '@/store/root_state';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';

const getters: GetterTree<CourseState, RootState> = {
  getCurrentChimeraCourse: (state) => {
    return state.currentChimeraCourse && new ChimeraCourseModel(state.currentChimeraCourse);
  },
  expiredChimeraCourseById:
    (state) =>
    (chimeraCourseId: string): ChimeraCourseModel | null => {
      const expiredChimeraCourseInfo = state.expiredChimeraCourses?.find(
        (c) => c._id === chimeraCourseId,
      );

      return expiredChimeraCourseInfo ? new ChimeraCourseModel(expiredChimeraCourseInfo) : null;
    },
  getChimeraUserCourses: (state) => {
    return state.chimeraCourses?.map((course) => new ChimeraCourseModel(course)) ?? [];
  },
  chimeraCourseMaterials: (state) => (chimeraCourseId: string) => {
    return state.chimeraCoursesMaterials[chimeraCourseId];
  },
};

export default getters;
